import { Box } from "@mui/material";
import { useSelector } from "react-redux";

import { useModals } from "../../context/ModalContext";
import { selectRole } from "../../redux/features/user/selectors/userState.selectors";
import ResponsiveAppBar, { appBarHeight } from "../appbar/AppBar";
import { SidebarConnect } from "../common/SidebarConnect/SidebarConnect";
import { colors } from "../ui/colors";

export default function MainLayout2({ child, basePath, hideSidebar = false }) {
  const token = sessionStorage.getItem("token");

  const { expandItem } = useModals();
  const roleType = useSelector(selectRole);
  const companies = useSelector((state) => state.userState?.companies) ?? [];
  const hasCompany = companies.length > 0;

  const showSidebar =
    token &&
    (hasCompany || roleType === "superadmin" || roleType === "admin") &&
    (roleType === "employee" ||
      roleType === "business" ||
      roleType === "admin" ||
      roleType === "virtualReceptionist" ||
      roleType === "accountManager" ||
      roleType === "other" ||
      roleType === "superadmin");

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        minWidth: 0,
        // Same as AppBar / main: portal leaves mt gap; without this, body (CssBaseline white) shows through.
        backgroundColor: colors.warmWhite.base,
      }}
    >
      {token && <ResponsiveAppBar basePath={basePath} />}

      <Box
        sx={{
          display: "flex",
          flex: 1,
          width: "100%",
          background: colors.warmWhite.base,
          minWidth: 0,
          mt: token ? `${appBarHeight}px` : 0,
        }}
      >
        {showSidebar && !hideSidebar && (
          <Box data-testid="flownect-host-sidebar" sx={{ ml: 1, flexShrink: 0 }}>
            <SidebarConnect basePath={basePath} />
          </Box>
        )}

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            minHeight: token ? `calc(100vh - ${appBarHeight}px)` : "100vh",
            overflowY: "auto",
            pl: token && !hideSidebar ? { xs: 0, md: 4 } : 0,
            pr: token && !hideSidebar ? { xs: 1, md: 8 } : 0,
            py: token && !hideSidebar ? 3 : 0,
            width: "100%",
            backgroundColor: colors.warmWhite.base,
            position: "relative",
            minWidth: 0,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {child}
        </Box>
      </Box>

      <Box
        sx={{
          position: "fixed",
          bottom: 0,
          left: expandItem ? 128 : 38,
          zIndex: 10,
          mt: 1,
          padding: "8px 12px",
        }}
      ></Box>
    </Box>
  );
}
